import { render } from "./TextHighlight.vue?vue&type=template&id=36159c58"
import script from "./TextHighlight.vue?vue&type=script&lang=js"
export * from "./TextHighlight.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__